import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import logolight from "../../assets/images/logo-light.png";
import logodark from "../../assets/images/logo-dark.png";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import {
  moneyState,
  avatarState,
  coinsState,
  usernameState,
  newState,
  bannedState,
} from "../../Recoil/atom";

import { useSelector } from "react-redux";

import { Link } from "react-router-dom";

import withRouter from "../../components/Common/withRouter";
import api from "../../api";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSetRecoilState } from "recoil";

const Login = (props) => {
  document.title = "Login | Pokémon Radiance";
  const setMoney = useSetRecoilState(moneyState);
  const setCoins = useSetRecoilState(coinsState);
  const setUsername = useSetRecoilState(usernameState);
  const setNew = useSetRecoilState(newState);
  const setAvatar = useSetRecoilState(avatarState);
  const setAuthState = useSetRecoilState(bannedState);

  // New state for success popup and error popup
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().max(30).required("Please Enter Your Username"),
      password: Yup.string().max(30).required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      const check_login = async () => {
        try {
          const resp = await api.post(
            "v1/login",
            {
              username: validation.values.username,
              password: validation.values.password,
            },
            { withCredentials: true },
          );
          if (resp.data.username) {
            // using resp.data for proper response object

            console.log(resp.data);
            const { money, coins, username, newuser, avatar } = resp.data;
            
            // Extract JWT token directly from response body
            const jwtToken = resp.data.token;
            
            // Set state and local storage
            localStorage.setItem("authUser", username);
            
            // Store JWT token in localStorage for WebSocket authentication
            if (jwtToken) {
              localStorage.setItem("jwtToken", jwtToken);
              console.log("JWT token stored in localStorage:", jwtToken);
            } else {
              console.error("No JWT token found in response");
              // Fallback to username only if token is not available (should not happen with updated backend)
              localStorage.setItem("jwtToken", username);
            }
            
            console.log(resp.data.username);

            if (resp.data.banned > 0) {
              setAuthState({
                ...resp.data,
                banned: true,
              });
            } else {
              setAuthState({
                ...resp.data,
                banned: false,
              });
            }
            setMoney(money);
            setCoins(coins);
            setAvatar(avatar);
            setUsername(username);
            setNew(newuser);

            // Show success popup and redirect after 2 seconds
            setShowSuccess(true);
            setTimeout(() => {
              props.router.navigate("/dashboard");
            }, 2000);
          }
        } catch (err) {
          setShowPopup(true);
          setTimeout(() => setShowPopup(false), 4000);
          console.log(err);
          // Store the error message from the backend response
          if (err.response && err.response.data && err.response.data.detail) {
            localStorage.setItem('loginErrorMessage', err.response.data.detail);
          } else {
            localStorage.setItem('loginErrorMessage', 'Something isn\'t right. Please try again.');
          }
        }
      };
      check_login();
    },
  });

  const { error } = useSelector((state) => ({
    error: state.login.error,
  }));

  useEffect(() => {
    document.body.className = "bg-pattern";
    return () => {
      document.body.className = "";
    };
  }, []);

  return (
    <React.Fragment>
      {/* Success message */}
      {showSuccess && (
        <Alert
          color="success"
          fade
          className="position-fixed top-0 start-50 translate-middle-x mt-3 shadow"
          style={{ zIndex: 1060, width: "auto", minWidth: 300 }}
        >
          <i className="mdi mdi-check-circle-outline me-2"></i>
          Login successful. Redirecting to Dashboard...
        </Alert>
      )}
      {/* Error message */}
      {!showSuccess && showPopup && (
        <Alert
          color="danger"
          fade
          className="position-fixed top-0 start-50 translate-middle-x mt-3 shadow"
          style={{ zIndex: 1060, width: "auto", minWidth: 300 }}
        >
          <i className="mdi mdi-alert-outline me-2"></i>
          {localStorage.getItem('loginErrorMessage') || "Something isn't right. Please try again."}
        </Alert>
      )}
      <div className="bg-overlay">
        <div className="account-pages my-5 pt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={4}>
                <Card>
                  <CardBody className="p-4">
                    <div>
                      <div className="text-center">
                        <Link to="/">
                          <img
                            src={logodark}
                            alt=""
                            height="24"
                            className="auth-logo logo-dark mx-auto"
                          />
                          <img
                            src={logolight}
                            alt=""
                            height="24"
                            className="auth-logo logo-light mx-auto"
                          />
                        </Link>
                      </div>
                      <h4 className="font-size-18 text-muted mt-2 text-center">
                        Welcome Back!
                      </h4>
                      <p className="mb-5 text-center">
                        Sign in to continue to Pokémon Radiance.
                      </p>
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        {error && !showSuccess ? (
                          <Alert color="danger">
                            <div>{error}</div>
                          </Alert>
                        ) : null}
                        <Row>
                          <Col md={12}>
                            <div className="mb-4">
                              <Label className="form-label">Username</Label>
                              <Input
                                name="username"
                                className="form-control"
                                placeholder="Enter Username"
                                type="username"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                invalid={
                                  validation.touched.username &&
                                  validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.username &&
                              validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.username}</div>
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-4">
                              <Label className="form-label">Password</Label>
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type="password"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password &&
                                  validation.errors.password
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.password &&
                              validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.password}</div>
                                </FormFeedback>
                              ) : null}
                            </div>

                            <Row>
                              <Col>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="customControlInline"
                                  />
                                  <label
                                    className="form-label form-check-label"
                                    htmlFor="customControlInline"
                                  >
                                    Remember me
                                  </label>
                                </div>
                              </Col>
                              <Col className="col-7">
                                <div className="text-md-end mt-3 mt-md-0">
                                  <span
                                    style={{ cursor: "pointer" }}
                                    className="text-muted"
                                    onClick={() => setShowForgotModal(true)}
                                  >
                                    <i className="mdi mdi-lock"></i> Forgot your
                                    password?
                                  </span>
                                </div>
                              </Col>
                            </Row>
                            <div className="d-grid mt-4">
                              <button
                                className="btn btn-danger waves-effect waves-light"
                                type="submit"
                              >
                                Log In
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                      <div className="mt-3 text-center small">
                        By logging in, you agree to our{" "}
                        <span
                          onClick={() => setShowTermsModal(true)}
                          style={{ cursor: "pointer" }}
                          className="text-primary"
                        >
                          Terms and Conditions
                        </span>
                        .
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p className="text-white-50">
                    Don't have an account?{" "}
                    <Link to="/register" className="fw-medium text-primary">
                      Register
                    </Link>
                  </p>
                  <p className="text-white-50">
                    1995–{new Date().getFullYear()}, GAME FREAK Inc.,
                    Creatures Inc., Nintendo. No commerce activities take place
                    on this website.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* Forgot-password Modal */}
      <Modal
        isOpen={showForgotModal}
        toggle={() => setShowForgotModal(false)}
        backdrop="static"
      >
        <ModalHeader toggle={() => setShowForgotModal(false)}>
          Forgot Password
        </ModalHeader>
        <ModalBody>
          If you have forgotten your password, please notify a staff member on our Discord server.
          They will help you recover your account.
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setShowForgotModal(false)}>
            Got it
          </Button>
        </ModalFooter>
      </Modal>

      {/* Terms and Conditions Modal */}
      <Modal
        isOpen={showTermsModal}
        toggle={() => setShowTermsModal(!showTermsModal)}
        size="lg"
      >
        <ModalHeader toggle={() => setShowTermsModal(!showTermsModal)}>
          Terms and Conditions
        </ModalHeader>
        <ModalBody style={{ maxHeight: "400px", overflowY: "auto" }}>
          <p>
            <strong>Pokémon Radiance</strong> is an online Pokémon RPG website
            designed to provide an engaging gaming experience while supporting
            various charities.
          </p>
          <p>
            <strong>Disclaimer:</strong> This site is a fan-made, non-profit
            project and is not affiliated with, endorsed by, or sponsored by
            Gamefreak, Nintendo, Nintendo of Japan, Nintendo of America,
            Creatures, or any other company that owns the rights to Pokémon.
          </p>
          <p>
            All Pokémon-related trademarks and copyrights belong to their
            respective owners.
          </p>
          <p>
            By logging in, you acknowledge that you have read and agree to these
            terms.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowTermsModal(false)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
